import Checkbox from "@components/inputs/CheckBox";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface NotificationTableRowProps {
  title: string;
  email: boolean;
  rounded?: boolean;
  onEmailChange: () => void;
  isEmailEnabled?: boolean;
  loading?: boolean;
}

const NotificationsTableRow: React.FC<NotificationTableRowProps> = ({
  title,
  email,
  rounded = false,
  isEmailEnabled,
  onEmailChange,
  loading,
}) => {
  return (
    <tr className={`${rounded ? "rounded-b-lg" : ""}`}>
      <td
        className={`${
          !rounded && "border-b border-border-table"
        } py-[15px] px-[8px] font-medium ${rounded ? "rounded-bl-lg" : ""}`}
      >
        {!loading ? (
          <div className="flex items-center h-full text-[14px] text-text-base font-normal">
            {title}
          </div>
        ) : (
          <Skeleton width={100} height={20} />
        )}
      </td>
      <td className={`${!rounded && "border-b border-border-table"} py-2 px-4`}>
        <div className="flex justify-center items-center h-full">
          <Checkbox
            onChange={onEmailChange}
            checked={email}
            isEnabled={isEmailEnabled}
            loading={loading}
          />
        </div>
      </td>
    </tr>
  );
};

export default NotificationsTableRow;
